import * as yup from 'yup';

export const phoneNumberValidation = yup
  .string()
  .nullable()
  .required('Phone number is required')
  // eslint-disable-next-line func-names
  .test('phone-number-has-10-digits', 'You must enter a 10-digit phone number', function(value) {
    if (!value) {
      // Let the .required() test handle it
      return true;
    }

    return !(value.replace(/[-() ]/g, '').length < 10);
  });
